import React, { memo, useEffect, useState } from 'react';
import { Button, Menu, MenuItem } from 'investira.react.components';

/** Seletor local dos controles de rentabilidade. */
const AtivoRentabilidadeSelectMenu = memo(({ value, options = [], onChange, renderValue }) => {
  const [selected, setSelected] = useState(value);
  const [anchorEl, setAnchorEl] = useState(null);
  const xCurrent = options.find((xOption) => xOption.value === selected);

  // Mantém o texto selecionado sincronizado quando o benchmark padrão muda.
  useEffect(() => {
    setSelected(value);
  }, [value]);

  const pvSelect = (pValue) => { onChange?.(pValue); setSelected(pValue); setAnchorEl(null); };
  return <><Button variant="outlined" size="small" disableElevation onClick={(pEvent) => setAnchorEl(pEvent.currentTarget)}>{renderValue ? renderValue(selected) : xCurrent?.label}</Button><Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>{options.map((xOption) => <MenuItem key={xOption.value} onClick={() => pvSelect(xOption.value)} disabled={xOption.disabled}>{xOption.label}</MenuItem>)}</Menu></>;
});

export default AtivoRentabilidadeSelectMenu;
